import Hero from "../Components/Hero";
import Navbar from "../Components/Navbar";
import AboutImg from "../Assets/night.jpg";
import Footer from "../Components/Footer";
import AboutUs from "../Components/AboutUs";
function About() {
  return (
    <>
      <Navbar />
      <Hero cName="hero-mid" heroImg={"https://media.istockphoto.com/id/1567694426/photo/landscape-of-asia-tropical-rainforest-canopy-tree-of-jungle-green-forest-park-outdoor-nature.webp?b=1&s=170667a&w=0&k=20&c=N_GaMMQBJN-BQNPo44C6oivZe-Z99_eFnKIKz0uoCDs="} title="About" btnClass="hide" />
      <AboutUs />
      <Footer />
    </>
  );
}

export default About;
